module.exports = __webpack_public_path__ + "d67d3642f5adc34ef10d7bcc368d90ef.png";